module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "churchlogo-header.8b8de2fc.png";